<template>
  <b-form-checkbox v-model="vip" switch inline :uncheckedValue="0" :value="1">
    خرید جدا از ترم
  </b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";
export default {
  components: {
    BFormCheckbox,
  },
  props: {
    propVip: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    vip: {
      get() {
        return this.propVip;
      },
      set(val) {
        this.$emit("input", val);
        this.$nextTick(() => this.$emit("validate"));
      },
    },
  },
};
</script>

<style></style>
